import { NotificationTemplate } from '../components/admin/notification/store/types';
import { api } from './services';

export const dismissNotification = async (reqBody: { notificationId: number }) => await api('notification/dismiss', { ...reqBody }, 'post');
export const dismissAllNotifications = async () => await api('notification/dismissAll', {}, 'post');

// Admin
export const sendNotification = async (reqBody: { notification: NotificationTemplate; }) => await api('notification/send', { ...reqBody }, 'post');
